import Swiper from 'swiper/js/swiper';
import { $win, videoControlPlayer } from './utils';

const videoControls = () => {
	$('.js-btn-video-play').on('click', function() {
		const $btn = $(this);
		const $iframe = $btn.closest('.hero__slide__video').find('iframe');
		const isPlaying = $btn.hasClass('playing');

		if (!isPlaying ) {
			$btn.addClass('playing');

			videoControlPlayer($iframe, 'play');
		} else {
			$btn.removeClass('playing');

			videoControlPlayer($iframe, 'pause');
		}

	});
}

const initSlider = () => {
	const $sliderWrap = $('.js-slider-hero');
	const $slider = $sliderWrap.find('.swiper-container');
	const $slides = $sliderWrap.find('.swiper-slide');
	const shouldAutorotate = $sliderWrap.data('autorotate');
	const hasVideo = $sliderWrap.find('.hero__slide__video').length === 0 ? false : true;
	const $btnAutoplay = $sliderWrap.find('.js-slider-autoplay');
	const options = {};

	if ( shouldAutorotate && !hasVideo ) {
		options.autoplay = {
			delay: 6000
		};

		$sliderWrap.addClass('autorotate');

		$btnAutoplay.addClass('playing');
	}

	if ($slides.length === 1) {
		$sliderWrap.addClass('not-initialized');

		options.autoplay = false;
		options.loop = false;
		options.allowTouchMove = false;
	}

	const slider = new Swiper($slider, {
		loop: true,
		simulateTouch: false,
		preloadImages: false,
		lazy: {
			loadPrevNext: true,
		},
		speed: 500,
		navigation: {
			prevEl: $slider.find('.js-paging-prev'),
			nextEl: $slider.find('.js-paging-next'),
		},
		...options
	});

	$sliderWrap.find('.hero__slide__video iframe').each(function() {
		const $iframe = $(this);

		if ( $iframe.data('src') ) {
			$iframe.attr('src', $iframe.data('src'));
		}
	});

	$btnAutoplay.on('click', () => {
		if (slider.autoplay.running) {
			slider.autoplay.stop();
		} else {
			slider.autoplay.start();
		}

		$btnAutoplay.toggleClass('playing', slider.autoplay.running);
	});
}

function setHeroHeight() {
	const $heroItems = $('.hero--full .hero__slide');
	const reduceSpace = 45;

	if ($heroItems.length) {
		const onResize = function() {
			const docHeight = $(window).outerHeight();
			$heroItems.css({height: docHeight - reduceSpace});
	    };

	    $win.on('resize', onResize);
	    
	    onResize();
	}
}

export default function heroUI() {
	initSlider();

	videoControls();

	setHeroHeight();
}
